import React from 'react';
import ProductContext from './memory/CategoryContext';
import { v4 as uuidv4 } from 'uuid';
import { motion } from 'framer-motion';

export interface TableInputProps {
  getTableProps: any
  getTableBodyProps: any
  headerGroups: any
  rows: any
  prepareRow: any
  tbleDataMiddleware?: any
  tableStateLoading?: any
  jwtToken?: any
  tableStateError?: any
  userData?: any
  tableStateLogout?: any
  errorCode?: any
}

class Table extends React.Component<TableInputProps> {
  protected stylingTrComp: any;
  protected stylingThComp: any;
  protected stylingTrBodyComp: any;
  protected stylingTheadComp: any;
  protected stylingTBodyComp: any;
  protected stylingTableComp: any;
  protected stylingTdComp: any;

  protected getTableProps: any;
  protected getTableBodyProps: any;
  protected headerGroups: any;
  protected rows: any;
  protected prepareRow: any;
  protected tbleDataMiddleware: any;
  protected tableStateLoading: any;

  protected buttonClicks: any;
  protected jwtToken: any;
  protected tableStateError: any;

  static ProductContext = ProductContext;

  public constructor(props: any) {
    super(props);
    this.getTableProps = this.props.getTableProps;
    this.getTableBodyProps = this.props.getTableBodyProps;
    this.headerGroups = this.props.headerGroups;
    this.rows = this.props.rows;
    this.prepareRow = this.props.prepareRow;
    this.tbleDataMiddleware = this.props.tbleDataMiddleware;
    this.tableStateLoading = this.props.tableStateLoading;
    this.tableStateError = this.props.tableStateError;
  }

  componentDidUpdate(prevProps: any) {
    this.tbleDataMiddleware = this.props.tbleDataMiddleware;
    this.tableStateLoading = this.props.tableStateLoading;
    this.getTableProps = this.props.getTableProps;
    this.getTableBodyProps = this.props.getTableBodyProps;
    this.headerGroups = this.props.headerGroups;
    this.rows = this.props.rows;
    this.prepareRow = this.props.prepareRow;
  }

  public thComp(column: any) {
    return (
      <th {...column.getHeaderProps()} className={this.stylingThComp} key={uuidv4()}>
        {column.render('Header')}
      </th>
    );
  }

  public trBodyComp(headerGroup: any) {
    return (
      <tr {...headerGroup.getHeaderGroupProps()} className={this.stylingTrComp}>
        {headerGroup.headers.map((column: any) => this.thComp(column))}
      </tr>
    );
  }

  public theadComp() {
    return <thead className={this.stylingTheadComp}>{this.props.headerGroups.map((headerGroup: any) => this.trBodyComp(headerGroup))}</thead>;
  }

  public tdComp(cell: any) {
    return (
      <td className={this.stylingTdComp} {...cell.getCellProps()} key={uuidv4()}>
        {cell.render('Cell')}
      </td>
    );
  }

  public trComp(row: any, i: any) {
    return (
      <motion.tr
        initial={{ opacity: 0, y: -50 }}
        animate={{
          opacity: 1,
          y: 0,
          transition: {
            duration: i * 0.06, // Adjust the duration here (1 second in this example)
          },
        }}
        exit={{ opacity: 0, y: -50 }}
        {...row.getRowProps()}
        className={this.stylingTrComp}
      >
        {row.cells.map((cell: any) => {
          return this.tdComp(cell);
        })}
      </motion.tr>
    );
  }

  public tBodyComp() {
    return (
      <tbody {...this.props.getTableBodyProps()} className={this.stylingTBodyComp}>
        {this.props.rows.map((row: any, i: any) => {
          this.prepareRow(row);
          return this.trComp(row, i);
        })}
      </tbody>
    );
  }

  public tableComp() {
    return (
      <motion.table initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} {...this.getTableProps()} className={this.stylingTableComp}>
        {this.theadComp()}
        {this.tBodyComp()}
      </motion.table>
    );
  }

  render() {
    return (
      <ProductContext.Consumer>
        {(context) => (
          <>
            {/* {context?.setJwtToken(this.jwtToken)} */}
            {this.tableComp()}
          </>
        )}
      </ProductContext.Consumer>
    );
  }
}

export default Table;
